export enum QualifyFormatConstants {
  Adaptation = "L",
  Original = "O",
}